import React, { PureComponent  , Fragment} from 'react';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,ResponsiveContainer
} from 'recharts';
import _ from 'lodash' ;

const data = [
    {
        NAME: 'Page A', uv: 4000, pv: 2400, amt: 2400,
    },
    {
        NAME: 'Page B', uv: 3000, pv: 1398, amt: 2210,
    },
    {
        NAME: 'Page C', uv: 2000, pv: 9800, amt: 2290,
    },
    {
        NAME: 'Page D', uv: 2780, pv: 3908, amt: 2000,
    },
    {
        NAME: 'Page E', uv: 1890, pv: 4800, amt: 2181,
    },
    {
        NAME: 'Page F', uv: 2390, pv: 3800, amt: 2500,
    },
    {
        NAME: 'Page G', uv: 3490, pv: 4300, amt: 2100,
    },
];

export default class LinearChart extends PureComponent {
    static jsfiddleUrl = 'https://jsfiddle.net/alidingling/xqjtetw0/';

    render() {
        const {chartData} = this.props ;
        console.log(chartData) ;
        return (
            <ResponsiveContainer width="100%" height={500}>
            <LineChart
                // width={chartData ? chartData.width : 500}
                // height={chartData ? chartData.height : 300}
                data={chartData ? chartData.data : data}
                margin={{
                    top: chartData ? chartData.margin.top : 30, right: chartData ? chartData.margin.right : 30, left: chartData ? chartData.margin.left : 20, bottom: chartData ? chartData.margin.bottom : 5,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="NAME" />
                <YAxis tick={false}/>
                <Tooltip position={{x:-30 , y : 30}}/>
                <Legend />
                {
                    chartData ?
                    _.map(chartData.lines , line => {
                        return <Line type="monotone" dataKey={line.keyName} stroke={line.color} strokeWidth={5} activeDot={{r : 8}} />
                    }) :

                            <Line type="monotone" dataKey="pv" stroke="#8884d8" strokeWidth={8} activeDot={{r : 5}}/>

                }
                {/*<Line type="monotone" dataKey="pv" stroke="#82ca9d" strokeWidth={2} activeDot={{r : 5}}/>*/}
            </LineChart>
            </ResponsiveContainer>
        );
    }
}
